import { TYPES } from "../actions/emailerAction";

const {
  API_REQUEST,
  API_ERROR,
  API_SUCCESS,

  GET_EMAILER_LIST_SUCCESS,
  CREATE_EMAILER_SUCCESS,
} = TYPES;

const initialState = {
  loading: false,
  error: "",
  emailers: [],
};

const emailerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EMAILER_SUCCESS:
      return {
        ...state,
        emailers: [action.data, ...state.emailers],
        loading: false,
      };

    case GET_EMAILER_LIST_SUCCESS:
      return {
        ...state,
        emailers: action.data,
        loading: false,
      };

    case API_REQUEST:
      return { ...state, loading: true };

    case API_ERROR:
      return {
        ...state,
        presentationError: action.data,
        loading: false,
      };

    case API_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default emailerReducer;
